import { Layout, theme } from 'antd'
import { Outlet } from "react-router-dom";

import GlobalMenu from "../global-menu";
import RenderHeader from './components/RenderHeader';

import './style.scss'
import { useEffect } from 'react';

const { Header, Sider, Content } = Layout;


const PageLayout = props => {
    const {
        token: { colorBgContainer },
    } = theme.useToken();

    useEffect(() => {
        let userInfo = JSON.parse(localStorage.getItem('USER_INFO') || '{}')
        if (!userInfo?.id) window.location.href = '/9165/login'
    }, [])

    return <Layout className="layout-mng-container">
        <Header className='layout-mng-header' style={{ background: colorBgContainer }}>
            <RenderHeader />
        </Header>
        <Layout>
            <Sider collapsible theme='light'>
                <GlobalMenu />
            </Sider>
            <Content>
                <Outlet />
            </Content>
        </Layout>
        {/* <Footer>Footer</Footer> */}
    </Layout>
}

export default PageLayout
